import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('city_shop_freight'),
  all_categories: []
}

const getters = {
  ...restful.getters('city_shop_freight'),
  all_categories: (state) => state.all_categories
}

const actions = {
  ...restful.actions('city_shop_freights'),
  async allCategory ({ commit }) {
    const res = await axios.get('city_shop_freights?per=10000')
    commit('all_categories', res.data)
  }
}

const mutations = {
  ...restful.mutations('city_shop_freight'),
  all_categories (state, all_categories) {
    state.all_categories = all_categories
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
